var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 24h-16c-2.2 0-4-1.8-4-4v-16c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4z",
    fill: "#f09d3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.6 10.2-9-7c-.4-.3-.9-.3-1.2 0l-9 7c-.4.3-.5 1-.2 1.4s1 .5 1.4.2l1.4-1.1v7.3c0 1.7 1.3 3 3 3h8c1.7 0 3-1.3 3-3v-7.3l1.4 1.1c.2.1.4.2.6.2.3 0 .6-.1.8-.4.3-.4.2-1.1-.2-1.4zm-4.6 7.8c0 .6-.4 1-1 1h-8c-.6 0-1-.4-1-1v-8.8l5-3.9 5 3.9z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4a4d87c04d18ffa67225949c277b75dd.svg";
export { ForwardRef as ReactComponent };